export enum ShiftPostPage {
  POST_SHIFT = 'POST_SHIFT',
  EDIT_SHIFT = 'EDIT_SHIFT',
  COPY_SHIFT = 'COPY_SHIFT',
}
